import React, { useEffect } from "react";
import { auth, signInWithGoogle, loginInWithEmailAndPassword } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate, Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import { Formik, FormikErrors } from "formik";

function Login() {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) {
      return;
    }
    if (user) navigate("/dashboard");
  }, [user, loading]);
  const signin = function(email: string, password: string) {
    loginInWithEmailAndPassword(email, password);
  }
  interface FormValues {
    email: string,
    password: string,
  }
  return (
    <div className="m-5">
      <Row className="justify-content-md-center">
        <Col>
          <div className="login form-signin">
            <div className="login__container">
              <Button className="login__btn login__google" onClick={signInWithGoogle}>
                Inciar sesion con Google
              </Button>
              <p className="mt-3">O con email y contraseña</p>
              <Formik
                initialValues={
                  {
                    email: "",
                    password: ""
                  }
                }
                onSubmit={async (values, actions) => {
                  actions.setSubmitting(true);
                  signin(values.email, values.password);
                }}
                validate={(values: FormValues) => {
                  let errors: FormikErrors<FormValues> = {};
                  if(!values.email) {
                    errors.email = "Obligatorio"
                  }
                  if(!values.password) {
                    errors.password = "Obligatorio"
                  }
                  return errors;
                }}
              >
                {({errors, touched, values, handleSubmit, handleChange}) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col className="col-12 col-sm-6">
                        <Form.Control type="text" name="email" value={values.email} placeholder="Correo electronico" onChange={handleChange} />
                        {errors.email && touched.email && <Alert variant="danger">{errors.email}</Alert>}
                      </Col>
                      <Col className="col-12 col-sm-6">
                        <Form.Control type="password" name="password" value={values.password} placeholder="Contraseña" onChange={handleChange} />
                        {errors.password && touched.password && <Alert variant="danger">{errors.password}</Alert>}
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        <Button variant="primary" type="submit">
                          Enviar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </div>
            <div className="mt-3">
              <Link to="/reset">He olvidado la contraseña</Link>
            </div>
            <div>
              ¿No tiene cuenta? <Link to="/register">Darse de alta</Link> ahora.
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
export default Login;
